<template>
  <ContactAdd/>
</template>

<script>
import ContactAdd from "./ContactAdd";
export default {
  name: "ContactEdit",
  components:{
    ContactAdd
  }
}
</script>

<style scoped>

</style>
